import { wait } from './wait';

export class Throttler {
  private requestBacklog: Array<number> = [];
  private requestLimitPromise?: Promise<void>;

  constructor(
    public readonly requestsPerSecond: number,
    public throttleAdjust: number = 0
  ) {}

  public requestLimitHit() {
    this.requestLimitPromise = wait(1000);
  }

  public increaseThrottleCount(): Promise<void> {
    const now = new Date().getTime();
    const oneSecondAgo = now - 1000 - this.throttleAdjust;
    this.requestBacklog = this.requestBacklog.filter(x => x > oneSecondAgo);

    if (this.requestBacklog.length < this.requestsPerSecond) {
      this.requestBacklog.push(now);
      return Promise.resolve();
    }

    return new Promise(resolve => {
      const inner = () => {
        const waitTime = this.requestBacklog[0]! - oneSecondAgo;
        setTimeout(() => {
          resolve(this.increaseThrottleCount());
        }, waitTime);
      };

      if (this.requestLimitPromise) {
        this.requestLimitPromise.then(inner);
      } else {
        inner();
      }
    });
  }
}
